export const PostTopics = [
  "Accounting",
  "Acrobatics",
  "Acroyoga",
  "Adventure Running",
  "Adventuring",
  "Air Gardening",
  "Airbrushing",
  "Aircraft Spotting",
  "Airplane Combat",
  "Airsoft",
  "Airsofting",
  "Alcohol infusion",
  "Amateur Geology",
  "Amazon ventures",
  "Anagram Designing",
  "Animal Craft",
  "Animation",
  "Anti-Gravity Cocooning",
  "Antiquing",
  "Aquascaping",
  "Archaeology",
  "Archery",
  "Architecture",
  "Art Collecting",
  "Art Galleries",
  "Arts And Crafts",
  "Astrology",
  "Astronomy",
  "Attend Renaissance Fairs",
  "Audiophile",
  "Auto Customization",
  "Auto Detailing",
  "Babysitting",
  "Backpacking",
  "Badminton",
  "Baking",
  "Balloon Twisting",
  "Ballroom Dancing",
  "Barbecuing",
  "Bartending",
  "Base Jumping",
  "Baseball",
  "Basketball",
  "Baton Twirling",
  "Beach / Sand Building",
  "Beach Volleyball",
  "Beachcombing",
  "Beadwork",
  "Beat Box",
  "Beatboxing",
  "Become A Wikipedia Editor",
  "Becoming A Film Buff",
  "Becoming A Fitness Instructor",
  "Becoming A Local Guide",
  "Becoming A Rail Fan",
  "Becoming An Alcohol Connoisseur",
  "Beekeeping",
  "Beer Tasting",
  "Being A Handyman",
  "Being A History Buff",
  "Bible Reading",
  "Bicycle Polo",
  "Bicycling",
  "Bird Watching",
  "Blacksmithing",
  "Board Game Club",
  "Board Surfing",
  "Boat Making",
  "Boat Racing",
  "Book Clubs",
  "Book Restoration",
  "Bookbinding",
  "Boomerangs",
  "Bouldering",
  "Bowling",
  "Boxing",
  "Break Dancing",
  "Brewing Beer",
  "Bridge Building",
  "Building Dollhouses",
  "Building Electronics",
  "Building Ships In Bottles",
  "Building Tesla Coils",
  "Butterfly Watching",
  "Buying And Selling",
  "Cake Decorating",
  "Calligraphy",
  "Camping",
  "Candle Making",
  "Canoeing",
  "Car Racing",
  "Card Tricks",
  "Carpet Weaving",
  "Cartography",
  "Cartooning",
  "Cash Flow Planning",
  "Catering",
  "Cave Diving",
  "Caving",
  "Ceramics",
  "Chainsaw Carving",
  "Chandlery",
  "Cheerleading",
  "Cheese",
  "Chocolate Making",
  "Chocolate Tasting",
  "Cigar Aficionado",
  "Circuits Training",
  "Cliff Diving",
  "Cloud Watching",
  "Coaching Local Sports",
  "Coding",
  "Coffee Roasting",
  "Coin Collecting",
  "Collage Making",
  "Collect Trainers",
  "Collecting Baseball Cards",
  "Collecting Comic Books",
  "Collecting Diecast Cars",
  "Collecting Leaves",
  "Collecting Marbles",
  "Collecting Military Paraphernalia",
  "Collecting Model Trains",
  "Collecting Sea Glass",
  "Collecting Seashells",
  "Collecting Stamps",
  "Collecting Stickers",
  "Color Guard",
  "Coloring",
  "Comic Book Art",
  "Community Activism",
  "Competitive Eating",
  "Computer Technician",
  "Container Gardening",
  "Conworlding",
  "Cookie Decorating",
  "Cooking",
  "Cosplaying",
  "Couponing",
  "Crabbing",
  "Create And Sell Gourmet Pet Treats",
  "Create Or Sell Pet Clothing",
  "Creating And/Or Editing Videos",
  "Creating Family Trees",
  "Creating Video Tutorials",
  "Credit Card Collecting",
  "Crocheting",
  "Croquet",
  "Cross Country Running",
  "Crossword Puzzles",
  "Cryptography",
  "Curling",
  "Current Affairs",
  "DIY",
  "Dancing",
  "Dandyism",
  "Decluttering",
  "Decorating Homes",
  "Deltiology",
  "Digital Scrapbooking",
  "Dinner Parties",
  "Discover Microscopy",
  "Distilling",
  "Dog Sport",
  "Dog Training",
  "Dog Walking",
  "Doing Science Experiments",
  "Doll Making",
  "Dominoes",
  "Drag Boat Racing",
  "Dragon Boat Racing",
  "Drawing",
  "Drive Others Around",
  "Drone Flying",
  "Dumpster Diving",
  "Ebay ventures",
  "Eggshell Carving",
  "Electro Band",
  "Embroidery",
  "Engravings",
  "Entrepreneurialism",
  "Event Hosting",
  "Exercising",
  "Falconry",
  "Fantasy Sports",
  "Farming",
  "Fell Running",
  "Felting",
  "Fencing",
  "Feng Shui Decorating",
  "Field Hockey",
  "Finger Painting",
  "Fire Poi",
  "Firearm Enthusiast",
  "Fish Tournaments",
  "Fishing",
  "Fishkeeping",
  "Fitness Or Yoga Trainer",
  "Flag Football",
  "Flea Market Shopping",
  "Flipping Items",
  "Floristry",
  "Flower Arranging",
  "Flower Making",
  "Flower Pressing",
  "Fly Fishing",
  "Fly Tying",
  "Flying",
  "Flying Drones",
  "Flying Model Planes",
  "Foraging",
  "Fossil Hunting",
  "Fostering Animals",
  "Found A Charity Group",
  "Four Wheeling",
  "Freediving",
  "Frolf",
  "Fruit Carving",
  "Furniture Making",
  "Gardening",
  "Genealogy",
  "Geocaching",
  "Geometry",
  "Ghost Hunting",
  "Gin",
  "Giving Advice Or Opinions",
  "Glass Blowing",
  "Glowsticking",
  "Gnoming",
  "Go Kart Racing",
  "Go To Free Community Events",
  "Golf",
  "Graphic Design",
  "Graphology",
  "Grilling",
  "Grip Strength",
  "Growing Bonsais",
  "Guerrilla Gardening",
  "Gun Collecting",
  "Gunsmithing",
  "Gymnastics",
  "Gyotaku",
  "Ham Radio",
  "Hang Gliding",
  "Helping The Homeless",
  "Herping",
  "Hiking",
  "Historical Reenactments",
  "Home Brewing",
  "Home Staging",
  "Homesteading",
  "Hookah Smoking",
  "Horseback Riding",
  "Hot Air Ballooning",
  "Hunting",
  "Ice Fishing",
  "Impersonations",
  "Improv",
  "Indie Band",
  "Insect Interest",
  "Inventing",
  "Investing",
  "Jam Making",
  "Jet Sprint Boat Racing",
  "Jewellery Making",
  "Journaling",
  "Juggling",
  "Jump Roping",
  "Karate",
  "Kicksled",
  "Kinetic Sculpture Racing",
  "Kitchen Chemistry",
  "Kite Flying",
  "Kitesurfing",
  "Knapping",
  "Knife Making",
  "Knife Throwing",
  "Knitting",
  "Knotting",
  "Lacemaking",
  "Lacrosse",
  "Lamp Making",
  "Landscaping",
  "Lapidary",
  "Laser Tag",
  "Latin language",
  "Latte Art",
  "Leaf Collecting And Pressing",
  "Learn About Philosophy",
  "Learn To Sew",
  "Learning A New Sport",
  "Learning How To Play Musical Instruments",
  "Learning Sign Language",
  "Leather Making",
  "Leather Tooling",
  "Lego Building/Assembling",
  "Letterboxing",
  "Life Coaching",
  "Lock Picking",
  "Lomography",
  "LudoSport",
  "Macrame",
  "Magic Tricks",
  "Making Bookmarks",
  "Making Key Holders",
  "Making Model Cars",
  "Making Music",
  "Making T-Shirts",
  "Making Time Capsules",
  "Making Your Own Hot Sauce",
  "Marathons",
  "Martial Arts",
  "Massage",
  "Matchstick Modeling",
  "Medical Anaesthesia",
  "Medical Andrology",
  "Medical Biochemistry",
  "Medical Cardiac",
  "Medical Cellular Pathology",
  "Medical Cosmetics",
  "Medical Dementia",
  "Medical Dermatology",
  "Medical Haematology",
  "Medical Microbiology",
  "Medical Pathology",
  "Medical Physiotherapy",
  "Medical Radiology",
  "Meditation",
  "Memory Improvement",
  "Metal Detecting",
  "Metal Working",
  "Meteorology",
  "Mini Golf",
  "Miniatures",
  "Minimalism",
  "Mobile Technician",
  "Model Rockets",
  "Model Rockets",
  "Model Ship Building",
  "Motocross",
  "Motorcycling",
  "Mountain Biking",
  "Mountaineering",
  "Music Memorabilia",
  "Music Writing",
  "Nature Walk",
  "Neuro Linguistic Programming",
  "Noodling",
  "Off Roading",
  "Organize Fundraising",
  "Orienteering Sports",
  "Origami",
  "Outrigger Canoe Racing",
  "Paid Surveys",
  "Paintballing",
  "Painting",
  "Palm Reading",
  "Paper Mache",
  "Papermaking",
  "Parachuting",
  "Paragliding",
  "Parkour – Freerunning",
  "Pencil Carving",
  "Pencil Sketching",
  "People Watching",
  "Performing Stand Up Comedy",
  "Pet Grooming",
  "Pet Sitting",
  "Photography",
  "Pickling",
  "Picnicking",
  "Pinochle",
  "Pipe Making",
  "Plan Walking Tours",
  "Playing Chess",
  "Playing Darts",
  "Playing Pool",
  "Playing Football",
  "Podcasting",
  "Poetry",
  "Poker",
  "Polo",
  "Pottery",
  "Powerbocking",
  "Producing Electronic Music",
  "Programming",
  "Proofreading And Editing",
  "Public Speaking",
  "Puppet Making",
  "Puppetry",
  "Pursuing Credit Card Rewards",
  "Pyrotechnics",
  "Quran Reading",
  "Quilling",
  "RC Model Racing",
  "RV Travelling",
  "Racquetball",
  "Raising Animals",
  "Rapping",
  "Reading",
  "Recipe Creation",
  "Record Collecting",
  "Reef Aquarium",
  "Refinishing Furniture",
  "Renovating",
  "Restoring Furniture",
  "Retro Gaming",
  "Reviewing Gadgets",
  "Reviewing Things",
  "River Rafting",
  "Road Biking",
  "Road Trips",
  "Robot Making",
  "Rock And Mineral Collecting",
  "Rock Balancing",
  "Rock Band",
  "Rock Climbing",
  "Rock Painting",
  "Roller Blading",
  "Rubix Cube",
  "Rugby",
  "Running",
  "Sailing",
  "Salsa Dancing",
  "Sand Art",
  "Sandboarding",
  "Scale Miniature Building",
  "Scouting",
  "Scrapbooking",
  "Screen Printing",
  "Scuba Diving",
  "Sculling Or Rowing",
  "Sculpt With Clay/ Playdough",
  "Sculpting",
  "Search Engine Marketing",
  "Self Defense",
  "Self-Care",
  "Shark Diving",
  "Shell Fishing",
  "Shooting/Marksmanship",
  "Silver Making",
  "Singing",
  "Skateboarding",
  "Skating",
  "Skeet Shooting",
  "Skiing/Snowboarding",
  "Skijoring",
  "Skimboarding",
  "Skydiving",
  "Slacklining",
  "Slingshots",
  "Smoking Meat",
  "Snorkeling",
  "Snowmobiling",
  "Soap Making",
  "Social Media",
  "Solitaire",
  "Solving Mazes",
  "Spanish language",
  "Spear Fishing",
  "Speed Reading",
  "Speed Skating",
  "Spike Ball",
  "Sports – Refereeing",
  "Squash",
  "Stamp Collecting",
  "Star Gazing",
  "Star Watching",
  "Start An Allotment",
  "Start Ground Hopping",
  "Starting A YouTube Channel",
  "Stock Market",
  "Stone Skipping",
  "Stone Working",
  "Storm Chasing",
  "Story-Writing",
  "Storytelling",
  "String Figures",
  "Sudoku",
  "Surf Fishing",
  "Surf Lifesaving",
  "Surfing",
  "Survival Skills",
  "Sushi Making",
  "Swimming",
  "T-Ball",
  "Table Tennis",
  "Tai Chi",
  "Taking Free Online Classes",
  "Tapestry",
  "Tapping Maple Trees",
  "Tarot Reading",
  "Tatebanko",
  "Tatting",
  "Tattoo Designing",
  "Tattooing",
  "Taxidermy",
  "Tea Drinking",
  "Tennis",
  "Tequila Tasting",
  "Terrarium Making",
  "Tomahawk/Hatchet Throwing",
  "Tombstone Rubbing",
  "Tool Collecting",
  "Tour Skating",
  "Touring Wineries",
  "Tower Running",
  "Track Cycling",
  "Trail Running",
  "Trainspotting",
  "Travel Hacking",
  "Traveling",
  "Treasure Hunting",
  "Trekking",
  "Trivia",
  "Tutoring Children",
  "Tutoring Music",
  "Ultimate Frisbee",
  "Upcycling",
  "Upholstery",
  "Urban Exploration",
  "Urban Fruit Picking",
  "Ventriloquism",
  "Video Games",
  "Vinyl Collecting",
  "Volunteering",
  "Wakeboarding",
  "Walking",
  "Wall Art",
  "War gaming",
  "Watch Documentaries",
  "Watch Making",
  "Water Ski",
  "Weather",
  "Website Optimization",
  "Weight Lifting",
  "Whale Watching",
  "Wheel Throwing",
  "Whiskey",
  "Whisky Tasting",
  "Whittling",
  "Windsurfing",
  "Wine",
  "Wine Making",
  "Wingsuit Flying",
  "Woodburning",
  "Woodworking",
  "Working On Cars",
  "Working Out",
  "World Record Breaking",
  "Wrestling",
  "Writing Letters",
  "Writing Music",
  "Writing/Blogging",
  "Yo-Yoing",
  "Yoga",
  "Ziplining",
  "Zoo Visits",
  "Zumba",
  "Celebrating",
  "Mental Health",
  "Miscellaneous",
  "It’s a secret",
  "New idea",
];
export const PostTypes = [
  "A question",
  "An experience",
  "An idea",
  "A milestone",
  "Help needed",
  "A memory",
];
export const tabs = ["Feed Content", "Feed Tags", "Feed Posting"];
export const modificationTabs = ["Feed Content", "Feed Tags"];



// WEBPACK FOOTER //
// ./src/screens/Feeds/constants/selections.js